module.exports = __webpack_public_path__ + "assets/img/11_741.26b8bc43.jpg";